import Vue from 'vue';
import Router from 'vue-router';
Vue.use(Router);

/* Layout */
import Layout from '@/views/layout';
import HomeRouter from '@/components/HomeRouter.vue';

const constantRoutes = [
  {
    path: '/',
    component: Layout,
    redirect: '/home/index',
    name: '首页',
    meta: { title: '老师帮', icon: 'dashboard' },
    children: [
      {
        path: '/home/index',
        component: HomeRouter
      }
    ]
  },
  {
    path: '/apps',
    component: Layout,
    redirect: '/apps/index',
    name: '应用',
    meta: { title: '老师帮', icon: 'dashboard' },
    children: [
      {
        path: '/apps/index',
        component: () => import('@/views/home/index')
      }
    ]
  },
  {
    path: '/chat',
    component: Layout,
    redirect: '/chat/index',
    name: '会话',
    meta: { title: '老师帮', icon: 'dashboard' },
    children: [
      {
        path: 'index',
        name: 'chat',
        component: () => import('@/views/chat/index')
      },
      {
        path: ':uri',
        name: 'chatWithUri',
        component: () => import('@/views/chat/index')
      }
    ]
  },
  {
    path: '/my',
    component: Layout,
    redirect: '/my/index',
    name: '我的',
    meta: { title: '老师帮', icon: 'dashboard' },
    children: [
      {
        path: 'index',
        component: () => import('@/views/my/index')
      }
    ]
  },
  {
    path: '/code',
    component: () => import('@/views/code/index'),
  },
  {
    path: '/video',
    component: () => import('@/views/video/index'),
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/404'),
  },
  {
    path: '/sso',
    component: () => import('@/views/sso/index'),
  },
  // 404 page must be placed at the end !!!
  { path: '*', redirect: '/', hidden: true }
];

const createRouter = () =>
  new Router({
    mode: 'history',
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  });

const router = createRouter();

export function resetRouter() {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
}

// 更新页面 SEO 信息
export function updateSEOInfo(seoInfo) {
  if (!seoInfo) return;
  
  console.log('正在更新 SEO 信息:', seoInfo);
  
  const { title, description, keyWords } = seoInfo;
  if (title) {
    document.title = title;
    console.log('更新页面标题为:', title);
  }
  
  // 更新 meta description
  let metaDescription = document.querySelector('meta[name="description"]');
  if (!metaDescription) {
    metaDescription = document.createElement('meta');
    metaDescription.name = 'description';
    document.head.appendChild(metaDescription);
    console.log('创建 description meta 标签');
  }
  metaDescription.content = description || '';
  console.log('更新 description 为:', description);

  // 更新 meta keywords
  let metaKeywords = document.querySelector('meta[name="keywords"]');
  if (!metaKeywords) {
    metaKeywords = document.createElement('meta');
    metaKeywords.name = 'keywords';
    document.head.appendChild(metaKeywords);
    console.log('创建 keywords meta 标签');
  }
  metaKeywords.content = keyWords || '';
  console.log('更新 keywords 为:', keyWords);
}

// 路由守卫
router.beforeEach(async (to, from, next) => {
  console.log('路由守卫触发 - to:', to.path, 'name:', to.name, 'params:', to.params, to.params.appSeoInfo);
  console.log('路由守卫触发 - from:', from.path, 'name:', from.name, from.params.appSeoInfo);
  
  // 处理 bd_vid
  const { bd_vid } = from.query;
  const newQuery = { ...to.query };
  
  if (bd_vid) {
    newQuery.bd_vid = bd_vid;
  }

  // 如果是带 URI 的聊天路由，获取项目信息
  if (to.name === 'chatWithUri' && to.params.uri) {
    const uri = to.params.uri;
    console.log('检测到 URI 路由:', uri);
    
    // 如果 params 中没有项目信息，从 localStorage 获取
    if (!to.params.appSeoInfo) {
      console.log('从 localStorage 获取项目信息...');
      const storedInfo = localStorage.getItem('appSeoInfo');
      let appSeoInfo = null;
      
      if (storedInfo) {
        try {
          const parsedInfo = JSON.parse(storedInfo);
          // 检查 URI 是否匹配
          if (parsedInfo.uri === uri) {
            appSeoInfo = parsedInfo;
          }
        } catch (e) {
          console.error('解析 localStorage 中的 appSeoInfo 失败:', e);
        }
      }
      
      if (appSeoInfo) {
        console.log('更新 SEO 信息', appSeoInfo);
        // 更新 SEO 信息
        updateSEOInfo(appSeoInfo);
        
        // 不进行重定向，直接继续，但将信息存储到路由中
        to.params.appSeoInfo = appSeoInfo;
      } else {
        console.warn('未找到对应的项目信息');
      }
    } else {
      // 如果已经有项目信息，更新 SEO
      console.log('使用现有的 appSeoInfo:', to.params.appSeoInfo);
      updateSEOInfo(to.params.appSeoInfo);
    }
  }

  // 处理其他 SEO 信息（从其他页面跳转过来的情况）
  const appSeoInfoTemp = to.params.appSeoInfo;
  
  if (appSeoInfoTemp && to.name === 'chat') {
    // 如果有 uri 且当前路由是 chat，需要重定向到 chatWithUri
    if (appSeoInfoTemp.uri) {
      console.log('重定向到带 URI 的路由:', appSeoInfoTemp.uri);
      next({
        name: 'chatWithUri',
        params: { uri: appSeoInfoTemp.uri, appSeoInfo: appSeoInfoTemp },
        query: newQuery,
        replace: true
      });
      return;
    } else {
      // 没有 uri，直接更新 SEO
      updateSEOInfo(appSeoInfoTemp);
    }
  }

  // 如果 query 有变化，需要更新路由
  if (bd_vid && to.query.bd_vid !== bd_vid) {
    next({ ...to, query: newQuery, replace: true });
    return;
  }

  next();
});

export default router;
